/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './line.stache';

const leaderboardLink = window.globalSettings.pagePaths.leaderboard;

Component.extend({
    tag: 'leaderboard-mini-line',
    template: template,
    viewModel: {
        define: {
            activeId: {
                type: 'string',
                value: '',
            },
            player: {
                type: '*',
            },
            short: {
                type: 'boolean',
                value: false,
            },
        },
    },
    events: {
        '.s-leaderboard-mini-line-short, leaderboard-drawer-mini .s-table-cell.s-table-cell--control click': function(
            $el,
        ) {
            if (
                !this.viewModel.attr('short') &&
                !this.viewModel.attr('isLive')
            ) {
                const playerId = this.viewModel.attr('player.identifier');

                this.viewModel.attr(
                    'activeId',
                    this.viewModel.activeId === playerId ? '' : playerId,
                );
            }
        },
    },
});
